module.exports = __webpack_public_path__ + "5d251b9568fd2fa61ec4b2922a18e4e8.png";